var _path, _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEyeOpenIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 12c1.006-2 4.966-6 11-6s10.162 4 11 6c-1.006 2-4.966 6-11 6s-9.994-4-11-6zm11 5.143c3.038 0 5.5-2.303 5.5-5.143S15.038 6.857 12 6.857 6.5 9.16 6.5 12s2.462 5.143 5.5 5.143z",
    fill: "#9A9CAC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 4,
    fill: "#9A9CAC"
  })));
}

export default SvgEyeOpenIcon;